import { Range } from '@/components/reports/types';
import { EMPTY_VALUE } from '@/constants';

export const displayAgeRange = (range: Range | undefined): string => {
    const { from, to } = range || {};

    if (!from && !to) return EMPTY_VALUE;

    if (from && !to) return `A partir de ${from} anos`;

    return `De ${from} até ${to} anos`;
};
